import {
    Component,
    Inject,
    ViewEncapsulation,
} from '@angular/core';
import _ from 'lodash';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MemberStatus } from 'src/app/models/projects/submodels/members.model';
import { MembersService } from 'src/app/services/member.service';
import { IProofreadingMember, ProofreadingMember } from 'src/app/models/proofreading-member.model';
import { Proofreading } from 'src/app/models/proofreading.model';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { ViewComponent } from 'src/app/shared/pages/view/view.component';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { LoaderService } from 'src/app/services/loader.service';
import { FormGroupComponent } from 'src/app/shared/pages/form-group/form-group.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { IGeneralInfo } from 'src/app/models/projects/submodels/general-info.model';
import { ProjectService } from 'src/app/services/project.service';
import { MasterProjectService } from 'src/app/services/project-master.service';


@Component({
    selector: 'app-members-proofreading-crud-modal',
    templateUrl: './members-proofreading-crud-modal.component.html',
    styleUrls: ['./members-proofreading-crud-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MembersProofreadingCrudModal extends FormGroupComponent<IProofreadingMember[]> {
    public readonly: boolean = false;

    protected _members: ProofreadingMember[] | undefined;
    get members(): ProofreadingMember[] {
        if (this._members) return this._members;
        return this.s_members.members || [];
    }
    get main_member(): ProofreadingMember | undefined {
        return this.members.find(member => member.hasApproDocument);
    }

    get current_approval_number(): number {
        return this.members?.filter(member => member.status === MemberStatus.ACCEPT || member.status === MemberStatus.REJECT).length || 0;
    }

    get total_approval_number(): number {
        return this.members?.filter(member => member.hasApproDocument || member.hasApproInfo).length || 0;
    }

    get proofreading(): Proofreading | undefined {
        return this.s_proofreading.current;
    }

    get current_order(): number {
        return this.proofreading?.current_order || 0;
    }

    get hasPreemptiveRefusal() {
        return this.members.filter(m => m.hasPreemptiveRight && m.status === MemberStatus.REJECT).length;
    }

    master_form: FormGroup;

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        @Inject(MAT_DIALOG_DATA) public data: { members?: ProofreadingMember[], readonly: boolean; },
        protected s_proofreading: ProofreadingService,
        protected s_project: ProjectService,
        protected s_master_project: MasterProjectService,
        protected s_members: MembersService,
        protected dialog: MatDialog,
        protected fb: FormBuilder,
    ) {
        super(route, router, s_alert, s_loader, s_auth);
        this._members = data.members;
        this.readonly = data.readonly;
        this.form = this.fb.group({});
        this.master_form = this.fb.group({
            custom: this.fb.group({
                general_info: this.fb.group({
                    marque: new FormControl(this.s_project.current?.custom?.general_info?.marque),
                }),
            }),
        });
    }


    async onSave() {
        const raw = this.form.getRawValue();
        for (let i = 0; i < raw.members.length; i++) {
            const member = raw.members[i];
            const memberIndex = this.members.findIndex(m => _.isEqual(m.usersID, member.usersID));
            if (memberIndex !== -1) {
                raw.members[i] = new ProofreadingMember({
                    ...this.members[memberIndex],
                    ...member,
                });
            } else {
                raw.members[i] = new ProofreadingMember({ ...member, status: MemberStatus.PENDING });
            }
        }
        await this.s_proofreading.patchCurrent(raw);
        this.dialog.closeAll();
    }
}

